import { render, staticRenderFns } from "./AddNewInvoice.vue?vue&type=template&id=0c5ccd40&scoped=true&"
import script from "./AddNewInvoice.vue?vue&type=script&lang=js&"
export * from "./AddNewInvoice.vue?vue&type=script&lang=js&"
import style0 from "./AddNewInvoice.vue?vue&type=style&index=0&id=0c5ccd40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5ccd40",
  null
  
)

export default component.exports